module.exports = __webpack_public_path__ + "static/media/default.aa38ed81.png";